import { DELETE_ROLE, REFRESH_ROLES, UPDATE_ROLE, ADD_ROLE } from "../actions/role.action";

const initialState = {
  roles: [],
};

const roleReducer = (state = initialState, action) => {
  switch (action.type) {
    case REFRESH_ROLES:
      return {
        ...state,
        roles: action.roles,
      };
    case ADD_ROLE:
      return {
        ...state,
        roles: [...state.roles, action.role],
      };
    case UPDATE_ROLE:
      return {
        ...state,
        roles: state.roles.map((role) =>
          role.id === action.role.id ? action.role : role
        ),
      };
    case DELETE_ROLE:
      return {
        ...state,
        roles: state.roles.filter((role) => role.id !== action.roleId),
      };
    default:
      return state;
  }
}
export default roleReducer;
